"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_RO_TRANS = {
    'time picker': 'Selector Timp',
    'today': 'Astăzi',
    'set time': 'Setează Ora',
    'close': 'Închide',
    'confirm': 'Confirmă',
    'hour': 'Oră',
    'minute': 'Minut',
    'second': 'Secondă',
};
//# sourceMappingURL=ro.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/ro.js
// module id = ../../../../ng2-date-time-picker/locale/ro.js
// module chunks = 4